import { memo, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import {
    Section,
    SeeMore,
} from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { inventoryCertifiedTileClick } from 'reaxl-analytics-handlers';
import { CertifiedProgramOffer } from 'reaxl-molecules';

import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

import certifiedSponsorFetcher from '@/fetchers/srp/certifiedSponsorFetcher';

import Anchor from '@/components/Anchor/index.js';

function CertifiedProgramOfferContainer() {
    const listing = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);

    const { certifiedProduct = {}, inspectionLink = {}, makeCode = '' } = listing ?? {};

    const [certifiedSponsorData, setCertifiedSponsorData] = useState({});

    useEffect(() => {
        const getCertifiedSponsor = async () => {
            try {
                if (certifiedProduct.id) {
                    const certifiedData = await certifiedSponsorFetcher({ productId: certifiedProduct.id, makeCode });
                    setCertifiedSponsorData(certifiedData);
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error fetching certifiedSponsor:', error);
            }
        };
        getCertifiedSponsor();
    }, [certifiedProduct.id, makeCode]);

    const hasCertifiedContent = !!Object.keys(certifiedSponsorData).length;

    if (!hasCertifiedContent) {
        return (
            // Return an anchor element that enables hash scrolling
            <Anchor
                id="warrantySection"
            />
        );
    }

    const handleInspectionLinkClick = (event) => {
        sendClick(inventoryCertifiedTileClick, event, { co_txt_url: inspectionLink.text || certifiedSponsorData?.inspectionLink?.text });
    };

    return (
        <Section
            alignment="left"
            className="padding-vertical-4 padding-vertical-md-5"
            id="warrantySection"
        >
            <SeeMore
                className="see-more-cpo"
            >
                <CertifiedProgramOffer
                    data-cmp="cpo"
                    data={{ ...certifiedSponsorData, inspectionLink: certifiedSponsorData?.inspectionLink || inspectionLink }}
                    headingSize={3}
                    isTileHeading={false} // deprecated
                    showCtaLinks={false}
                    orientation="landscape"
                    onInspectionLinkClick={handleInspectionLinkClick}
                />
            </SeeMore>
        </Section>
    );
}

export default memo(CertifiedProgramOfferContainer);
